<script>
  import { onMount } from "svelte";
  import { customer } from "$lib/state/customer";
  
  /**@type {Date}*/
  let date;
  /**@type {number}*/
  let year;
  onMount(() => {
    date = new Date();
    year = date.getFullYear();
  });
  /**@type {boolean}*/
  let isOpen = false;

  let menu = {
    about: [
      {
        name: "Our Story",
        link: "/our-story",
      },
    ],
    warranty: [
      {
        name: "Warranty Registration",
        link: "/warranty-registration",
      },
      {
        name: "Warranty Support",
        link: "/warranty-support",
      },
    ],
    help: [
      {
        name: "FAQ",
        link: "/faq",
      },
      {
        name: "Patents",
        link: "/patents",
      },
      {
        name: "Shipping Policy",
        link: "/shipping-policy",
      },
      {
        name: "Return Policy",
        link: "/shipping-policy",
      },
      {
        name: "Privacy Policy",
        link: "/privacy",
      },
      {
        name: "Terms and Conditions",
        link: "/terms",
      },
    ],
    contact: [
      "1545 Moonstone Brea, CA 92821 United States of America",
      "weborders@nailalliance.com",
      "714-773-9758",
    ],
  };
  /**@type {any}*/
  // @ts-ignore
  let menuClicked;
  /**@type {string}*/
  let selected;
  /**@param {string}name*/
  const openSubFooter = (name) => {
    isOpen = true;
    // @ts-ignore
    menuClicked = menu[name];
    selected = name;
  };
</script>

<footer class="footer-container desktop">
  {#if !$customer?.customer}
    <div class="call-to-action">
      <span>BECOME A MEMBER</span>
      <p>Join now get a 15% discount on your next order!</p>
      <a href="/signup" aria-labelledby="sigup-page-in-page">Sign in</a>
    </div>
  {/if}
  <div class="footer">
    <div class="item">
      <span>About</span>
      <ul>
        <li>
          <a href="/our-story">Our Story</a>
        </li>
      </ul>
    </div>
    <div class="item">
      <span>Warranty</span>
      <ul>
        <li>
          <a href="/warranty-registration">Warranty Registration</a>
        </li>
        <li>
          <a href="/warranty-support">Warranty Support</a>
        </li>
      </ul>
    </div>
    <div class="item">
      <span>Help</span>
      <ul>
        <li>
          <a href="/faq">FAQ</a>
        </li>
        <li>
          <a href="/patents">Patents</a>
        </li>
        <li>
          <a href="/shipping-policy">Shipping Policy</a>
        </li>
        <li>
          <a href="/shipping-policy">Return Policy</a>
        </li>
        <li>
          <a href="/privacy">Privacy Policy</a>
        </li>
        <li>
          <a href="/terms">Terms and Conditions</a>
        </li>
      </ul>
    </div>
    <div class="contact item">
      <span>Contact</span>
      <p>
        1545 Moonstone<br />
        Brea, CA 92821<br />
        United States of America
      </p>
      <a href="mailto:weborders@nailalliance.com">
        weborders@nailalliance.com
      </a>
      <a href="tel:7147739758">714.773.9758</a>
      <div class="social-icons">
        <a href="/">
          <img
            width="38px"
            height="38px"
            src="/images/social/CF-approved@2x.png"
            alt="Cruelty Free"
          />
          <span class="label" id="sigup-page">Go to PETA page</span>
        </a>
        <a
          target="_blank"
          href="https://www.youtube.com/c/GelishOfficial"
          aria-labelledby="youtube-channel"
        >
          <img
            width="38px"
            height="38px"
            src="/images/social/icons8-youtube.svg"
            alt="Youtube"
          />
          <span class="label" id="youtube-channel">
            go to gelish youtube channel
          </span>
        </a>
        <a
          target="_blank"
          href="https://twitter.com/GelishPro"
          aria-labelledby="twitter-page"
        >
          <img
            width="38px"
            height="38px"
            src="/images/social/twitter.svg"
            alt="Twitter"
            class="twitter"
          />
          <span class="label" id="twitter-page">
            go to gelish twitter profile
          </span>
        </a>
        <a
          target="_blank"
          href="https://www.facebook.com/GelishProfessionalPage"
          aria-labelledby="facebook-page"
        >
          <img
            width="38px"
            height="38px"
            src="/images/social/icons8-facebook-nuevo.svg"
            alt="Facebook"
          />
          <span class="label" id="facebook-page">
            go to gelish facebook profile
          </span>
        </a>
        <a
          target="_blank"
          href="https://www.instagram.com/GelishProfessional"
          aria-labelledby="instagram-page"
        >
          <img
            width="38px"
            height="38px"
            src="/images/social/icons8-instagram.svg"
            alt="Instagram"
          />
          <span class="label" id="instagram-page">
            go to gelish instagram profile
          </span>
        </a>
        <a
          target="_blank"
          href="https://www.tiktok.com/@gelishpro"
          aria-labelledby="tiktok"
        >
          <img
            width="38px"
            height="38px"
            src="/images/social/icons8-tik-tok-48.svg"
            alt="Tiktok"
          />
          <span class="label" id="tiktok"> go to gelish tik tok profile </span>
        </a>
      </div>
    </div>
  </div>
  <div class="bottom-footer">
    <div class="content-bottom-footer">
      <div class="copy">
        <p>
          Copyright © {year} Nail Alliance - North America, Inc. All Rights Reserved.
        </p>
        <span>Nail Alliance - North America, Inc. PETA Certification.</span><br
        />
        <span>
          This site is protected by reCAPTCHA and the Google
          <a href="https://policies.google.com/privacy">Privacy Policy</a> and
          <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </span>
      </div>
      <div class="logo">
        <img
          src="/images/global/GelishMorganTaylorLogo_white.svg"
          alt="Gelish Mogan Taylor"
        />
      </div>
    </div>
  </div>
</footer>
<footer class="mobile-footer">
  <div class="mobile-buttons-container">
    <button on:click={() => openSubFooter("about")}> ABOUT </button>
    <button on:click={() => openSubFooter("warranty")}>WARRANTY </button>
    <button on:click={() => openSubFooter("help")}> HELP </button>
    <button on:click={() => openSubFooter("contact")}> CONTACT </button>
    <div class="content-subfooter" class:active={isOpen}>
      <button on:click={() => (isOpen = false)}>{selected}</button>
      {#if menuClicked}
        {#if selected == "contact"}
          <div class="contact">
            <p>{menuClicked[0]}</p>
            <a on:click={() => (isOpen = false)} href={`mailto:${menuClicked[1]}`}>{menuClicked[1]}</a>
            <a on:click={() => (isOpen = false)} href={`tel:${menuClicked[2]}`}>{menuClicked[2]}</a>
          </div>
        {:else}
          <div class="submenu">
            {#each menuClicked as submenu}
              <a on:click={() => (isOpen = false)} href={submenu.link}>{submenu.name}</a>
            {/each}
          </div>
        {/if}
      {/if}
    </div>
  </div>
  <div class="copy">
    <p>
      Copyright © {year} Nail Alliance - North America, Inc. All Rights Reserved.
    </p>
    <span>Nail Alliance - North America, Inc. PETA Certification.</span>
  </div>
</footer>

<style>
  footer {
    user-select: none;
    background-color: #333333;
    position: relative;
    /* z-index: 99; */
  }
  .mobile-footer {
    display: none;
  }
  li {
    list-style: none;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  .call-to-action {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 270px;
    width: 100%;
    text-align: center;
    padding: 0 10px;
    background-color: var(--primary-color);
    color: var(--secondary-color);
    font-family: "gotham-bold";
  }
  .call-to-action span {
    font-size: 2.625em;
    color: #c83830;
    padding: 0 0 8px 0;
    letter-spacing: 0;
  }
  .call-to-action p {
    font-size: 1.625em;
    letter-spacing: 0;
    font-family: "gotham-light";
  }
  .call-to-action a {
    text-decoration: none;
    color: var(--secondary-color);
    font-size: 1.625em;
    font-weight: 700;
    padding: 30px 10px 10px 10px;
    position: relative;
    border: none;
    background: none;
    cursor: pointer;
    letter-spacing: 0;
    display: block;
  }
  .call-to-action a::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #c83830;
  }
  .footer {
    color: #fdfdfd;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 3rem;
    max-width: 1720px;
    margin: 0 auto;
  }
  .item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 15px;
  }
  .item span {
    font-size: 1.4em;
    font-family: "gotham-medium";
  }
  .item ul li {
    padding: 7px 0;
  }
  .contact a {
    margin-top: 10px;
  }
  .social-icons {
    margin-top: 15px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
  }
  .social-icons img {
    width: 25px;
    height: 25px;
  }
  .social-icons .twitter {
    width: 20px;
    height: 20px;
  }
  .bottom-footer {
    width: 100svw;
    padding: 25px 0;
    background-color: #262626;
    color: #fdfdfd;
    gap: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content-bottom-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 95%;
    max-width: 1720px;
  }
  .copy p {
    font-size: 0.875em;
    font-family: "gotham-medium";
    line-height: 1;
  }
  .copy span {
    font-size: 0.825em;
    font-family: "gotham-light";
    line-height: 1;
  }
  .logo {
    max-width: 155px;
  }

  @media (max-width: 880px) {
    .footer {
      padding: 3rem 1rem;
    }
  }
  @media (max-width: 767px) {
    .desktop {
      display: none;
    }
    .mobile-footer {
      display: flex;
      flex-direction: column;
    }
    .mobile-buttons-container {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .mobile-buttons-container button {
      padding: 25px 0;
      background-color: #333333;
      border: none;
      width: 100%;
      color: #fff;
      font-size: clamp(0.75rem, 4vw, 1rem);
      text-transform: uppercase;
      font-family: "gotham-medium";
    }
    .content-subfooter {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 0;
      background-color: #333333;
      transition: all 0.5s ease;
      overflow: hidden;
      color: #fff;
    }
    .content-subfooter.active {
      height: 100%;
    }
    .submenu {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      display: flex;
      flex-direction: column;
      scrollbar-width: none;
    }
    .submenu a {
      display: block;
      width: 100%;
      text-align: center;
      padding: 5px 0;
    }
    .contact {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;
      width: 80%;
      margin: 0 auto;
      text-align: center;
    }
    .copy {
      color: #fff;
      text-align: center;
      padding: 30px 10px;
      background-color: #262626;
      font-size: 1rem;
      letter-spacing: 1px;
    }
    .copy p {
      line-height: 1.2;
    }
    .copy span {
      letter-spacing: 0.2px;
      line-height: 1.2;
    }
  }
</style>
